import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from '../home/components/Footer';
import { useSEO } from '../../utils/seo';

interface Article {
  id: number;
  category: string;
  categorySlug: string;
  title: string;
  excerpt: string;
  image: string;
  slug: string;
}

export default function BlogPage() {
  const [activeFilter, setActiveFilter] = useState('Tümü');
  const [searchQuery, setSearchQuery] = useState('');

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kgmdanismanlik.com';

  const categories = [
    { name: 'Tümü', slug: 'all' },
    { name: 'Devlet İzinleri', slug: 'devlet-izinleri' },
    { name: 'İhracat', slug: 'ihracat' },
    { name: 'Teşvikler', slug: 'tesvikler' },
    { name: 'Kalite Yönetimi', slug: 'kalite' },
    { name: 'Yazılım', slug: 'yazilim' },
    { name: 'Kalibrasyon', slug: 'kalibrasyon' },
    { name: 'Gıda Güvenliği', slug: 'gida-guvenligi' },
    { name: 'Çevre', slug: 'cevre' },
    { name: 'İSG', slug: 'isg' }
  ];

  const articles: Article[] = [
    // DEVLET İZİNLERİ
    {
      id: 1,
      category: 'Devlet İzinleri',
      categorySlug: 'devlet-izinleri',
      title: 'Kapasite Raporu Olmadan Neler Kaybedersiniz?',
      excerpt: 'Elektrik faturası indiriminden ihracat kayıtlarına kadar sanayicinin olmazsa olmazı Kapasite Raporu\'nun sağladığı 5 kritik avantaj.',
      image: 'https://public.readdy.ai/ai/img_res/cbf9ecbc04167a7707c44c4308826838.jpg',
      slug: 'kapasite-raporu-olmadan-neler-kaybedersiniz'
    },
    {
      id: 2,
      category: 'Devlet İzinleri',
      categorySlug: 'devlet-izinleri',
      title: 'Sanayi Sicil Belgesi ve Yıllık İşletme Cetveli Zorunluluğu',
      excerpt: 'İdari para cezalarıyla karşılaşmamak için sanayi sicil işlemlerinizi zamanında nasıl yapmalısınız?',
      image: 'https://readdy.ai/api/search-image?query=official%20industrial%20registry%20certificate%20and%20annual%20operation%20schedule%20documents%2C%20professional%20business%20desk%20with%20government%20compliance%20papers%2C%20modern%20corporate%20office%20setting%20with%20organized%20legal%20documentation%2C%20clean%20professional%20photography%20with%20dark%20charcoal%20and%20copper%20tones&width=800&height=500&seq=blog-sanayi-sicil&orientation=landscape',
      slug: 'sanayi-sicil-belgesi-ve-yillik-isletme-cetveli'
    },
    {
      id: 3,
      category: 'Devlet İzinleri',
      categorySlug: 'devlet-izinleri',
      title: 'Yerli Malı Belgesi Nasıl Alınır? 2025 Güncel Rehber',
      excerpt: 'Kamu ihalelerinde avantaj sağlayan Yerli Malı Belgesi için gerekli şartlar, başvuru süreci ve dikkat edilmesi gerekenler.',
      image: 'https://readdy.ai/api/search-image?query=Turkish%20domestic%20goods%20certificate%20with%20national%20flag%20symbol%2C%20government%20procurement%20advantage%20documentation%20on%20professional%20desk%2C%20clean%20corporate%20photography%20showing%20local%20manufacturing%20compliance%2C%20modern%20business%20consulting%20workspace%20with%20official%20stamps%20and%20certificates&width=800&height=500&seq=blog-yerli-mali&orientation=landscape',
      slug: 'yerli-mali-belgesi-nasil-alinir-2025-guncel-rehber'
    },
    {
      id: 4,
      category: 'Devlet İzinleri',
      categorySlug: 'devlet-izinleri',
      title: 'ÇED Raporu ve Çevre İzin Belgesi Süreçleri',
      excerpt: 'Yeni yatırımlarda Çevresel Etki Değerlendirmesi raporu hazırlama, ÇED kapsam dışı görüşü alma ve çevre izin belgesi başvuru adımları.',
      image: 'https://readdy.ai/api/search-image?query=environmental%20impact%20assessment%20report%20with%20green%20nature%20background%2C%20%C3%87ED%20documentation%20and%20environmental%20permit%20papers%20on%20desk%2C%20professional%20ecological%20consulting%20workspace%20showing%20sustainability%20compliance%2C%20clean%20corporate%20photography%20with%20natural%20elements&width=800&height=500&seq=blog-ced-raporu&orientation=landscape',
      slug: 'ced-raporu-ve-cevre-izin-belgesi-surecleri'
    },

    // İHRACAT
    {
      id: 5,
      category: 'İhracat',
      categorySlug: 'ihracat',
      title: 'Suudi Arabistan İhracatında SABER Sistemi ve PCoC Rehberi',
      excerpt: 'Ürünlerinizin gümrükte kalmaması için SABER kayıt sistemi ve teknik uygunluk süreçlerinde dikkat etmeniz gerekenler.',
      image: 'https://readdy.ai/api/search-image?query=Saudi%20Arabia%20SABER%20certification%20system%20digital%20interface%20on%20laptop%20screen%2C%20international%20export%20documentation%20and%20customs%20clearance%20papers%2C%20modern%20global%20trade%20consulting%20workspace%20with%20Middle%20East%20market%20focus%2C%20professional%20business%20photography%20with%20copper%20orange%20highlights&width=800&height=500&seq=blog-saber-sistem&orientation=landscape',
      slug: 'suudi-arabistan-ihracatinda-saber-sistemi-rehberi'
    },
    {
      id: 6,
      category: 'İhracat',
      categorySlug: 'ihracat',
      title: 'CE İşareti Nedir? Hangi Ürünler İçin Zorunludur?',
      excerpt: 'Avrupa pazarına açılmak isteyen üreticiler için teknik dosya hazırlama ve uygunluk beyanı süreçleri.',
      image: 'https://readdy.ai/api/search-image?query=CE%20mark%20certification%20badge%20on%20product%20with%20European%20Union%20flag%20background%2C%20technical%20file%20documentation%20and%20declaration%20of%20conformity%20papers%2C%20professional%20export%20compliance%20consulting%20workspace%2C%20clean%20corporate%20photography%20showing%20international%20standards&width=800&height=500&seq=blog-ce-isareti&orientation=landscape',
      slug: 'ce-isareti-nedir-hangi-urunler-icin-zorunludur'
    },
    {
      id: 7,
      category: 'İhracat',
      categorySlug: 'ihracat',
      title: 'EAC Sertifikasyonu: Avrasya Gümrük Birliği İhracatı',
      excerpt: 'Rusya, Kazakistan ve Belarus pazarlarına açılmak için EAC uygunluk belgesi alma süreci ve gerekli testler.',
      image: 'https://readdy.ai/api/search-image?query=EAC%20certification%20mark%20for%20Eurasian%20Customs%20Union%20with%20Russia%20Kazakhstan%20Belarus%20flags%2C%20international%20export%20compliance%20documentation%2C%20professional%20trade%20consulting%20workspace%20showing%20technical%20conformity%20assessment%2C%20clean%20corporate%20photography&width=800&height=500&seq=blog-eac-sertifika&orientation=landscape',
      slug: 'eac-sertifikasyonu-avrasya-gumruk-birligi-ihracati'
    },
    {
      id: 8,
      category: 'İhracat',
      categorySlug: 'ihracat',
      title: 'RoHS ve REACH Uyumluluğu: Avrupa Kimyasal Mevzuatı',
      excerpt: 'Elektronik ve kimyasal ürünlerde zararlı madde kısıtlamaları, test gereksinimleri ve uyumluluk beyanı hazırlama.',
      image: 'https://readdy.ai/api/search-image?query=RoHS%20and%20REACH%20compliance%20certification%20documents%20for%20European%20chemical%20regulations%2C%20laboratory%20testing%20equipment%20and%20hazardous%20substance%20restriction%20papers%2C%20professional%20environmental%20compliance%20workspace%2C%20clean%20corporate%20photography%20with%20safety%20symbols&width=800&height=500&seq=blog-rohs-reach&orientation=landscape',
      slug: 'rohs-ve-reach-uyumlulugu-avrupa-kimyasal-mevzuati'
    },
    {
      id: 9,
      category: 'İhracat',
      categorySlug: 'ihracat',
      title: 'TSE Ürün Belgelendirme ve İhracatta Kullanımı',
      excerpt: 'Türk Standartları Enstitüsü ürün belgesi alarak hem yurt içi hem yurt dışı pazarlarda güvenilirlik kazanma yolları.',
      image: 'https://readdy.ai/api/search-image?query=TSE%20Turkish%20Standards%20Institute%20product%20certification%20badge%20on%20manufactured%20goods%2C%20quality%20assurance%20documentation%20and%20export%20advantage%20papers%2C%20professional%20standards%20compliance%20workspace%2C%20clean%20corporate%20photography%20with%20national%20and%20international%20trade%20symbols&width=800&height=500&seq=blog-tse-urun&orientation=landscape',
      slug: 'tse-urun-belgelendirme-ve-ihracatta-kullanimi'
    },

    // TEŞVİKLER
    {
      id: 10,
      category: 'Teşvikler',
      categorySlug: 'tesvikler',
      title: '2025 Yılı Yatırım Teşvik Sistemi: Bölgeler ve Destekler',
      excerpt: 'Yeni fabrika kurulumu veya makine teçhizat alımlarında KDV ve Gümrük Vergisi muafiyetinden nasıl yararlanabilirsiniz?',
      image: 'https://readdy.ai/api/search-image?query=Turkey%20investment%20incentive%20system%20map%20showing%20regional%20development%20zones%2C%20modern%20factory%20construction%20with%20government%20support%20symbols%2C%20professional%20business%20consulting%20showing%20tax%20exemption%20benefits%20and%20machinery%20investment%2C%20clean%20corporate%20photography%20with%20financial%20growth%20charts&width=800&height=500&seq=blog-yatirim-tesvik&orientation=landscape',
      slug: '2025-yili-yatirim-tesvik-sistemi-bolgeler-destekler'
    },
    {
      id: 11,
      category: 'Teşvikler',
      categorySlug: 'tesvikler',
      title: 'KOSGEB İleri Girişimci Destek Programı Başvuru Şartları',
      excerpt: 'İşletmenizi büyütmek için hibe ve faizsiz kredi desteklerine ulaşmanın yol haritası.',
      image: 'https://readdy.ai/api/search-image?query=KOSGEB%20entrepreneurship%20support%20program%20application%20documents%20on%20modern%20desk%2C%20Turkish%20SME%20development%20grant%20and%20interest-free%20loan%20papers%2C%20professional%20business%20growth%20consulting%20workspace%2C%20clean%20corporate%20photography%20with%20success%20symbols%20and%20financial%20support%20elements&width=800&height=500&seq=blog-kosgeb-destek&orientation=landscape',
      slug: 'kosgeb-ileri-girisimci-destek-programi-basvuru'
    },
    {
      id: 12,
      category: 'Teşvikler',
      categorySlug: 'tesvikler',
      title: 'TÜBİTAK TEYDEB Ar-Ge Projeleri Destek Programı',
      excerpt: 'Teknoloji ve yenilik odaklı Ar-Ge projeleriniz için TÜBİTAK desteklerinden yararlanma koşulları ve başvuru süreci.',
      image: 'https://readdy.ai/api/search-image?query=TUBITAK research and development project support program documentation, innovation technology grant papers on modern desk, professional R&D consulting workspace showing scientific equipment and funding charts, clean corporate photography&width=800&height=500&seq=blog-tubitak-teydeb&orientation=landscape',
      slug: 'tubitak-teydeb-ar-ge-projeleri-destek-programi'
    },
    {
      id: 13,
      category: 'Teşvikler',
      categorySlug: 'tesvikler',
      title: 'Enerji Verimliliği Destekleri ve Yeşil Dönüşüm Teşvikleri',
      excerpt: 'İşletmenizde enerji tasarrufu sağlayan yatırımlar için devlet destekleri, yeşil sertifika programları ve karbon azaltım teşvikleri.',
      image: 'https://readdy.ai/api/search-image?query=energy%20efficiency%20support%20program%20with%20green%20transformation%20incentives%2C%20solar%20panels%20and%20sustainable%20technology%20investment%20documentation%2C%20professional%20environmental%20consulting%20workspace%20showing%20carbon%20reduction%20benefits%2C%20clean%20corporate%20photography%20with%20eco-friendly%20elements&width=800&height=500&seq=blog-enerji-verimlilik&orientation=landscape',
      slug: 'enerji-verimliligi-destekleri-ve-yesil-donusum-tesvikleri'
    },

    // KALİTE YÖNETİMİ - ISO 9001
    {
      id: 14,
      category: 'Kalite Yönetimi',
      categorySlug: 'kalite',
      title: 'ISO 9001 Kalite Yönetim Sistemi: Başlangıç Rehberi',
      excerpt: 'ISO 9001 standardının temel prensipleri, kurulum aşamaları ve işletmenize sağlayacağı rekabet avantajları.',
      image: 'https://readdy.ai/api/search-image?query=ISO%209001%20quality%20management%20system%20certification%20badge%20with%20professional%20business%20documentation%2C%20modern%20corporate%20office%20showing%20quality%20assurance%20processes%2C%20clean%20professional%20photography%20with%20organizational%20excellence%20charts%20and%20compliance%20standards&width=800&height=500&seq=blog-iso9001-baslangic&orientation=landscape',
      slug: 'iso-9001-kalite-yonetim-sistemi-baslangic-rehberi'
    },
    {
      id: 15,
      category: 'Kalite Yönetimi',
      categorySlug: 'kalite',
      title: 'ISO 9001:2015 Revizyonu ve Yeni Gereklilikler',
      excerpt: 'Risk tabanlı düşünce, liderlik vurgusu ve süreç yaklaşımı ile güncellenen ISO 9001:2015 standardına geçiş süreci.',
      image: 'https://readdy.ai/api/search-image?query=ISO%209001%202015%20revision%20documentation%20showing%20risk-based%20thinking%20and%20leadership%20requirements%2C%20modern%20quality%20management%20system%20upgrade%20papers%20on%20professional%20desk%2C%20clean%20corporate%20photography%20with%20process%20approach%20diagrams&width=800&height=500&seq=blog-iso9001-2015&orientation=landscape',
      slug: 'iso-9001-2015-revizyonu-ve-yeni-gereklilikler'
    },
    {
      id: 16,
      category: 'Kalite Yönetimi',
      categorySlug: 'kalite',
      title: 'ISO 9001 İç Tetkik Nasıl Yapılır? Denetim Kontrol Listesi',
      excerpt: 'Etkili iç tetkik planlaması, denetçi yetkinlikleri, bulgulara göre düzeltici faaliyet yönetimi ve sürekli iyileştirme döngüsü.',
      image: 'https://readdy.ai/api/search-image?query=ISO%209001%20internal%20audit%20checklist%20and%20inspection%20documentation%2C%20professional%20auditor%20reviewing%20quality%20management%20processes%2C%20modern%20corporate%20workspace%20showing%20compliance%20verification%20and%20corrective%20action%20management%2C%20clean%20photography&width=800&height=500&seq=blog-iso9001-ic-tetkik&orientation=landscape',
      slug: 'iso-9001-ic-tetkik-nasil-yapilir-denetim-kontrol-listesi'
    },
    {
      id: 17,
      category: 'Kalite Yönetimi',
      categorySlug: 'kalite',
      title: 'Kamu İhalelerinde HYB (Hizmet Yeterlilik Belgesi) Önemi',
      excerpt: 'Teknik servis ve hizmet noktaları için TSE onaylı HYB belgesi nasıl alınır, ihalelerde ne avantaj sağlar?',
      image: 'https://readdy.ai/api/search-image?query=TSE%20service%20qualification%20certificate%20HYB%20document%20with%20public%20tender%20bid%20papers%2C%20professional%20consulting%20workspace%20showing%20government%20procurement%20advantage%2C%20clean%20corporate%20photography%20with%20official%20certification%20badges%20and%20competitive%20bidding%20elements&width=800&height=500&seq=blog-hyb-belgesi&orientation=landscape',
      slug: 'kamu-ihalelerinde-hyb-hizmet-yeterlilik-belgesi'
    },

    // ÇEVRE YÖNETİMİ - ISO 14001
    {
      id: 18,
      category: 'Çevre',
      categorySlug: 'cevre',
      title: 'ISO 14001 Çevre Yönetim Sistemi Kurulumu',
      excerpt: 'Çevresel etkileri azaltmak, yasal uyumluluğu sağlamak ve sürdürülebilirlik hedeflerine ulaşmak için ISO 14001 standardı.',
      image: 'https://readdy.ai/api/search-image?query=ISO%2014001%20environmental%20management%20system%20certification%20with%20green%20nature%20background%2C%20sustainability%20documentation%20and%20ecological%20compliance%20papers%2C%20professional%20environmental%20consulting%20workspace%20showing%20pollution%20reduction%20and%20legal%20conformity&width=800&height=500&seq=blog-iso14001-kurulum&orientation=landscape',
      slug: 'iso-14001-cevre-yonetim-sistemi-kurulumu'
    },
    {
      id: 19,
      category: 'Çevre',
      categorySlug: 'cevre',
      title: 'ISO 14001 ve ISO 9001 Entegre Yönetim Sistemi',
      excerpt: 'Kalite ve çevre yönetim sistemlerini tek çatı altında birleştirerek operasyonel verimlilik ve maliyet tasarrufu sağlama.',
      image: 'https://readdy.ai/api/search-image?query=integrated%20management%20system%20combining%20ISO%2014001%20and%20ISO%209001%20certifications%2C%20professional%20business%20workspace%20showing%20unified%20quality%20and%20environmental%20processes%2C%20clean%20corporate%20photography%20with%20efficiency%20improvement%20charts&width=800&height=500&seq=blog-iso14001-9001-entegre&orientation=landscape',
      slug: 'iso-14001-ve-iso-9001-entegre-yonetim-sistemi'
    },
    {
      id: 20,
      category: 'Çevre',
      categorySlug: 'cevre',
      title: 'Çevresel Boyut ve Etki Değerlendirmesi Nasıl Yapılır?',
      excerpt: 'ISO 14001 kapsamında işletmenizin çevresel boyutlarını belirleme, önem derecelerini değerlendirme ve kontrol önlemleri alma.',
      image: 'https://readdy.ai/api/search-image?query=environmental%20aspect%20and%20impact%20assessment%20matrix%20documentation%2C%20professional%20ecological%20evaluation%20workspace%20showing%20significance%20rating%20and%20control%20measures%2C%20clean%20corporate%20photography%20with%20environmental%20monitoring%20charts&width=800&height=500&seq=blog-cevre-boyut-etki&orientation=landscape',
      slug: 'cevresel-boyut-ve-etki-degerlendirmesi-nasil-yapilir'
    },

    // İSG - ISO 45001
    {
      id: 21,
      category: 'İSG',
      categorySlug: 'isg',
      title: 'ISO 45001 İş Sağlığı ve Güvenliği Yönetim Sistemi',
      excerpt: 'İş kazalarını önlemek, çalışan sağlığını korumak ve yasal yükümlülükleri yerine getirmek için ISO 45001 standardı.',
      image: 'https://readdy.ai/api/search-image?query=ISO%2045001%20occupational%20health%20and%20safety%20management%20system%20certification%2C%20workplace%20safety%20equipment%20and%20accident%20prevention%20documentation%2C%20professional%20OHS%20consulting%20workspace%20showing%20employee%20protection%20and%20legal%20compliance&width=800&height=500&seq=blog-iso45001-isg&orientation=landscape',
      slug: 'iso-45001-is-sagligi-ve-guvenligi-yonetim-sistemi'
    },
    {
      id: 22,
      category: 'İSG',
      categorySlug: 'isg',
      title: 'OHSAS 18001\'den ISO 45001\'e Geçiş Süreci',
      excerpt: 'Eski OHSAS 18001 standardından yeni ISO 45001 standardına geçiş için yapılması gerekenler ve temel farklar.',
      image: 'https://readdy.ai/api/search-image?query=transition%20from%20OHSAS%2018001%20to%20ISO%2045001%20certification%20documents%2C%20professional%20workplace%20safety%20upgrade%20papers%20showing%20standard%20migration%20process%2C%20clean%20corporate%20photography%20with%20occupational%20health%20improvement%20charts&width=800&height=500&seq=blog-ohsas-iso45001&orientation=landscape',
      slug: 'ohsas-18001-den-iso-45001-e-gecis-sureci'
    },
    {
      id: 23,
      category: 'İSG',
      categorySlug: 'isg',
      title: 'Risk Değerlendirmesi ve İş Güvenliği Analizi',
      excerpt: 'İşyerindeki tehlikeleri belirleme, riskleri değerlendirme ve kontrol önlemleri alarak iş kazalarını minimize etme yöntemleri.',
      image: 'https://readdy.ai/api/search-image?query=workplace%20risk%20assessment%20and%20job%20safety%20analysis%20documentation%2C%20professional%20safety%20inspector%20evaluating%20hazards%20with%20control%20measures%20checklist%2C%20modern%20industrial%20workspace%20showing%20accident%20prevention%20strategies&width=800&height=500&seq=blog-risk-degerlendirme&orientation=landscape',
      slug: 'risk-degerlendirmesi-ve-is-guvenligi-analizi'
    },

    // GIDA GÜVENLİĞİ - ISO 22000 & FSSC 22000
    {
      id: 24,
      category: 'Gıda Güvenliği',
      categorySlug: 'gida-guvenligi',
      title: 'ISO 22000 Gıda Güvenliği Yönetim Sistemi Nedir?',
      excerpt: 'Gıda zincirindeki tüm organizasyonlar için HACCP prensipleri ile entegre edilmiş ISO 22000 standardı ve kurulum adımları.',
      image: 'https://readdy.ai/api/search-image?query=ISO%2022000%20food%20safety%20management%20system%20certification%20with%20HACCP%20principles%2C%20professional%20food%20industry%20quality%20control%20documentation%2C%20clean%20corporate%20photography%20showing%20food%20chain%20safety%20and%20hygiene%20standards&width=800&height=500&seq=blog-iso22000-nedir&orientation=landscape',
      slug: 'iso-22000-gida-guvenligi-yonetim-sistemi-nedir'
    },
    {
      id: 25,
      category: 'Gıda Güvenliği',
      categorySlug: 'gida-guvenligi',
      title: 'FSSC 22000 Sertifikasyonu: Global Gıda Güvenliği',
      excerpt: 'Uluslararası perakende zincirlerinin kabul ettiği FSSC 22000 şeması, ISO 22000 ile farkları ve sertifikasyon süreci.',
      image: 'https://readdy.ai/api/search-image?query=FSSC%2022000%20global%20food%20safety%20certification%20scheme%20documentation%2C%20international%20retail%20chain%20acceptance%20papers%2C%20professional%20food%20industry%20consulting%20workspace%20showing%20comprehensive%20safety%20standards&width=800&height=500&seq=blog-fssc22000&orientation=landscape',
      slug: 'fssc-22000-sertifikasyonu-global-gida-guvenligi'
    },
    {
      id: 26,
      category: 'Gıda Güvenliği',
      categorySlug: 'gida-guvenligi',
      title: 'HACCP Sistemi Kurulumu ve Kritik Kontrol Noktaları',
      excerpt: 'Gıda güvenliği tehlikelerini önlemek için HACCP\'in 7 prensibi, kritik kontrol noktalarının belirlenmesi ve izleme prosedürleri.',
      image: 'https://readdy.ai/api/search-image?query=HACCP%20system%20implementation%20with%20seven%20principles%20and%20critical%20control%20points%20documentation%2C%20professional%20food%20safety%20hazard%20analysis%20workspace%2C%20clean%20corporate%20photography%20showing%20monitoring%20procedures%20and%20food%20industry%20compliance&width=800&height=500&seq=blog-haccp-sistem&orientation=landscape',
      slug: 'haccp-sistemi-kurulumu-ve-kritik-kontrol-noktalari'
    },
    {
      id: 27,
      category: 'Gıda Güvenliği',
      categorySlug: 'gida-guvenligi',
      title: 'ISO 9001 ve ISO 22000 Entegrasyonu Nasıl Yapılır?',
      excerpt: 'Gıda işletmeleri için kalite ve gıda güvenliği yönetim sistemlerini tek çatı altında yönetmenin verimliliğe etkisi.',
      image: 'https://readdy.ai/api/search-image?query=ISO%209001%20and%20ISO%2022000%20integrated%20management%20system%20certificates%20for%20food%20industry%2C%20professional%20quality%20and%20food%20safety%20documentation%20on%20modern%20desk%2C%20clean%20corporate%20consulting%20workspace%20showing%20efficiency%20improvement%20charts%20and%20compliance%20standards&width=800&height=500&seq=blog-iso-entegrasyon&orientation=landscape',
      slug: 'iso-9001-ve-iso-22000-entegrasyonu-nasil-yapilir'
    },

    // BİLGİ GÜVENLİĞİ - ISO 27001
    {
      id: 28,
      category: 'Kalite Yönetimi',
      categorySlug: 'kalite',
      title: 'ISO 27001 Bilgi Güvenliği Yönetim Sistemi',
      excerpt: 'Siber saldırılar ve veri ihlallerine karşı kurumsal bilgi varlıklarınızı korumak için ISO 27001 standardı ve BGYS kurulumu.',
      image: 'https://readdy.ai/api/search-image?query=ISO%2027001%20information%20security%20management%20system%20certification%20with%20cybersecurity%20protection%2C%20professional%20data%20protection%20documentation%20and%20network%20security%20workspace%2C%20clean%20corporate%20photography%20showing%20digital%20asset%20safeguarding&width=800&height=500&seq=blog-iso27001-bgys&orientation=landscape',
      slug: 'iso-27001-bilgi-guvenligi-yonetim-sistemi'
    },
    {
      id: 29,
      category: 'Kalite Yönetimi',
      categorySlug: 'kalite',
      title: 'ISO 27001 Risk Değerlendirmesi ve Varlık Envanteri',
      excerpt: 'Bilgi varlıklarınızı belirleme, tehdit ve zafiyetleri analiz etme, risk seviyelerini hesaplama ve kontrol önlemleri seçme.',
      image: 'https://readdy.ai/api/search-image?query=ISO%2027001%20risk%20assessment%20matrix%20and%20asset%20inventory%20documentation%2C%20professional%20information%20security%20analysis%20workspace%20showing%20threat%20vulnerability%20evaluation%2C%20clean%20corporate%20photography%20with%20cybersecurity%20control%20measures&width=800&height=500&seq=blog-iso27001-risk&orientation=landscape',
      slug: 'iso-27001-risk-degerlendirmesi-ve-varlik-envanteri'
    },
    {
      id: 30,
      category: 'Kalite Yönetimi',
      categorySlug: 'kalite',
      title: 'KVKK ve ISO 27001 Uyumluluğu: Kişisel Veri Koruma',
      excerpt: 'Kişisel Verilerin Korunması Kanunu gereklilikleri ile ISO 27001 bilgi güvenliği kontrollerini entegre etme stratejileri.',
      image: 'https://readdy.ai/api/search-image?query=KVKK%20personal%20data%20protection%20law%20compliance%20with%20ISO%2027001%20information%20security%2C%20professional%20privacy%20documentation%20and%20GDPR%20alignment%20papers%2C%20clean%20corporate%20photography%20showing%20data%20protection%20integration&width=800&height=500&seq=blog-kvkk-iso27001&orientation=landscape',
      slug: 'kvkk-ve-iso-27001-uyumlulugu-kisisel-veri-koruma'
    },

    // ENERJİ YÖNETİMİ - ISO 50001
    {
      id: 31,
      category: 'Çevre',
      categorySlug: 'cevre',
      title: 'ISO 50001 Enerji Yönetim Sistemi ve Verimlilik',
      excerpt: 'Enerji tüketimini azaltmak, maliyetleri düşürmek ve karbon ayak izini minimize etmek için ISO 50001 standardı.',
      image: 'https://readdy.ai/api/search-image?query=ISO%2050001%20energy%20management%20system%20certification%20with%20efficiency%20improvement%20charts%2C%20professional%20energy%20consumption%20reduction%20documentation%2C%20clean%20corporate%20photography%20showing%20cost%20savings%20and%20carbon%20footprint%20minimization&width=800&height=500&seq=blog-iso50001-enerji&orientation=landscape',
      slug: 'iso-50001-enerji-yonetim-sistemi-ve-verimlilik'
    },

    // YAZILIM ÇÖZÜMLERİ
    {
      id: 32,
      category: 'Yazılım',
      categorySlug: 'yazilim',
      title: 'Excel ile Vedalaşın: Periyodik Muayene Takip Yazılımı',
      excerpt: 'Basınçlı kaplar ve kaldırma ekipmanları muayenelerinde hata payını sıfıra indiren dijital takip sistemimizle tanışın.',
      image: 'https://readdy.ai/api/search-image?query=modern%20digital%20periodic%20inspection%20tracking%20software%20dashboard%20on%20computer%20screen%20showing%20pressure%20vessels%20and%20lifting%20equipment%20management%2C%20professional%20industrial%20safety%20monitoring%20system%20interface%2C%20clean%20tech%20workspace%20with%20automated%20compliance%20tracking%2C%20copper%20orange%20and%20dark%20grey%20UI%20design&width=800&height=500&seq=blog-periyodik-yazilim&orientation=landscape',
      slug: 'excel-ile-vedalasın-periyodik-muayene-takip-yazilimi'
    },
    {
      id: 33,
      category: 'Yazılım',
      categorySlug: 'yazilim',
      title: 'Kalibrasyon Laboratuvarlarında Dijital Dönüşüm',
      excerpt: 'Numune kabulden sertifika basımına kadar tüm süreçleri TÜRKAK standartlarına uygun olarak dijitalleştirin.',
      image: 'https://readdy.ai/api/search-image?query=calibration%20laboratory%20digital%20transformation%20software%20showing%20sample%20acceptance%20to%20certificate%20printing%20workflow%2C%20modern%20TURKAK%20compliant%20lab%20management%20system%20interface%20on%20tablet%2C%20professional%20metrology%20workspace%20with%20automated%20processes%2C%20clean%20tech%20photography%20with%20precision%20measurement%20equipment&width=800&height=500&seq=blog-kalibrasyon-dijital&orientation=landscape',
      slug: 'kalibrasyon-laboratuvarlarinda-dijital-donusum'
    },
    {
      id: 34,
      category: 'Yazılım',
      categorySlug: 'yazilim',
      title: 'Dokümantasyon Yönetim Sistemi: ISO Süreçlerinde Dijitalleşme',
      excerpt: 'Prosedür, talimat ve formların dijital ortamda yönetimi, revizyon kontrolü ve elektronik onay süreçleri.',
      image: 'https://readdy.ai/api/search-image?query=digital%20document%20management%20system%20for%20ISO%20processes%2C%20professional%20electronic%20approval%20workflow%20interface%20showing%20procedure%20and%20instruction%20control%2C%20modern%20corporate%20workspace%20with%20revision%20tracking%20and%20digital%20signature%2C%20clean%20tech%20photography&width=800&height=500&seq=blog-dokuman-yonetim&orientation=landscape',
      slug: 'dokumantasyon-yonetim-sistemi-iso-sureclerinde-dijitallesme'
    },
    {
      id: 35,
      category: 'Yazılım',
      categorySlug: 'yazilim',
      title: 'Düzeltici ve Önleyici Faaliyet (DÖF) Takip Yazılımı',
      excerpt: 'Uygunsuzlukların kaydı, kök neden analizi, aksiyon planlaması ve etkinlik değerlendirmesi için dijital DÖF sistemi.',
      image: 'https://readdy.ai/api/search-image?query=corrective%20and%20preventive%20action%20CAPA%20tracking%20software%20dashboard%2C%20professional%20nonconformity%20management%20system%20showing%20root%20cause%20analysis%20and%20action%20planning%2C%20modern%20quality%20control%20workspace%20with%20effectiveness%20evaluation%20charts&width=800&height=500&seq=blog-dof-takip&orientation=landscape',
      slug: 'duzeltici-ve-onleyici-faaliyet-dof-takip-yazilimi'
    },

    // KALİBRASYON
    {
      id: 36,
      category: 'Kalibrasyon',
      categorySlug: 'kalibrasyon',
      title: 'Neden TÜRKAK Akrediteli Kalibrasyon Yaptırmalısınız?',
      excerpt: 'Uluslararası geçerliliği olan sertifikalar ile denetimlerden sorunsuz geçmenin ve doğru ölçümün önemi.',
      image: 'https://readdy.ai/api/search-image?query=TURKAK%20accredited%20calibration%20laboratory%20with%20precision%20measurement%20instruments%20and%20international%20certification%20documents%2C%20professional%20metrology%20workspace%20showing%20accurate%20measurement%20importance%2C%20clean%20corporate%20photography%20with%20calibration%20certificates%20and%20quality%20assurance%20symbols&width=800&height=500&seq=blog-turkak-kalibrasyon&orientation=landscape',
      slug: 'neden-turkak-akrediteli-kalibrasyon-yaptirmalısiniz'
    },
    {
      id: 37,
      category: 'Kalibrasyon',
      categorySlug: 'kalibrasyon',
      title: 'Kütle Kalibrasyonu: Terazi ve Kantar Kalibrasyonu',
      excerpt: 'Hassas tartım cihazlarınızın doğruluğunu sağlamak için TÜRKAK akrediteli kütle kalibrasyon hizmetleri ve periyotları.',
      image: 'https://readdy.ai/api/search-image?query=mass%20calibration%20service%20for%20precision%20scales%20and%20weighing%20instruments%2C%20TURKAK%20accredited%20weight%20calibration%20laboratory%20with%20standard%20weights%2C%20professional%20metrology%20workspace%20showing%20accuracy%20verification%20and%20calibration%20certificates&width=800&height=500&seq=blog-kutle-kalibrasyon&orientation=landscape',
      slug: 'kutle-kalibrasyonu-terazi-ve-kantar-kalibrasyonu'
    },
    {
      id: 38,
      category: 'Kalibrasyon',
      categorySlug: 'kalibrasyon',
      title: 'Sıcaklık Kalibrasyonu: Termometre ve Fırın Kalibrasyonu',
      excerpt: 'Üretim ve depolama süreçlerinde kritik öneme sahip sıcaklık ölçüm cihazlarının kalibrasyonu ve izlenebilirlik.',
      image: 'https://readdy.ai/api/search-image?query=temperature%20calibration%20service%20for%20thermometers%20and%20ovens%2C%20professional%20calibration%20laboratory%20with%20thermal%20measurement%20equipment%20and%20reference%20standards%2C%20clean%20metrology%20workspace%20showing%20traceability%20chain%20and%20calibration%20reports&width=800&height=500&seq=blog-sicaklik-kalibrasyon&orientation=landscape',
      slug: 'sicaklik-kalibrasyonu-termometre-ve-firin-kalibrasyonu'
    },
    {
      id: 39,
      category: 'Kalibrasyon',
      categorySlug: 'kalibrasyon',
      title: 'Basınç Kalibrasyonu: Manometre ve Transmitter Kalibrasyonu',
      excerpt: 'Endüstriyel süreçlerde kullanılan basınç ölçüm cihazlarının hassas kalibrasyonu ve ölçüm belirsizliği hesaplamaları.',
      image: 'https://readdy.ai/api/search-image?query=pressure%20calibration%20service%20for%20manometers%20and%20transmitters%2C%20TURKAK%20accredited%20pressure%20calibration%20laboratory%20with%20deadweight%20testers%2C%20professional%20metrology%20workspace%20showing%20measurement%20uncertainty%20calculations&width=800&height=500&seq=blog-basinc-kalibrasyon&orientation=landscape',
      slug: 'basinc-kalibrasyonu-manometre-ve-transmitter-kalibrasyonu'
    },
    {
      id: 40,
      category: 'Kalibrasyon',
      categorySlug: 'kalibrasyon',
      title: 'Boyut Kalibrasyonu: Kumpas ve Mikrometre Kalibrasyonu',
      excerpt: 'Hassas imalat süreçlerinde kullanılan boyut ölçüm aletlerinin kalibrasyonu ve ölçüm doğruluğunun sağlanması.',
      image: 'https://readdy.ai/api/search-image?query=dimensional%20calibration%20service%20for%20calipers%20and%20micrometers%2C%20precision%20measurement%20tools%20calibration%20laboratory%20with%20gauge%20blocks%2C%20professional%20metrology%20workspace%20showing%20manufacturing%20accuracy%20verification&width=800&height=500&seq=blog-boyut-kalibrasyon&orientation=landscape',
      slug: 'boyut-kalibrasyonu-kumpas-ve-mikrometre-kalibrasyonu'
    },

    // DİĞER STANDARTLAR
    {
      id: 41,
      category: 'Kalite Yönetimi',
      categorySlug: 'kalite',
      title: 'ISO 13485 Tıbbi Cihaz Kalite Yönetim Sistemi',
      excerpt: 'Tıbbi cihaz üreticileri ve tedarikçileri için özel gereklilikler içeren ISO 13485 standardı ve sertifikasyon süreci.',
      image: 'https://readdy.ai/api/search-image?query=ISO%2013485%20medical%20device%20quality%20management%20system%20certification%2C%20professional%20healthcare%20industry%20compliance%20documentation%2C%20clean%20corporate%20photography%20showing%20medical%20equipment%20manufacturing%20standards%20and%20regulatory%20requirements&width=800&height=500&seq=blog-iso13485-tibbi&orientation=landscape',
      slug: 'iso-13485-tibbi-cihaz-kalite-yonetim-sistemi'
    },
    {
      id: 42,
      category: 'Kalite Yönetimi',
      categorySlug: 'kalite',
      title: 'ISO 17025 Test ve Kalibrasyon Laboratuvarı Akreditasyonu',
      excerpt: 'Laboratuvarların teknik yeterliliğini kanıtlamak için ISO 17025 standardı, TÜRKAK akreditasyon süreci ve gereklilikleri.',
      image: 'https://readdy.ai/api/search-image?query=ISO%2017025%20testing%20and%20calibration%20laboratory%20accreditation%20certification%2C%20TURKAK%20accreditation%20process%20documentation%2C%20professional%20laboratory%20workspace%20showing%20technical%20competence%20and%20quality%20assurance%20standards&width=800&height=500&seq=blog-iso17025-lab&orientation=landscape',
      slug: 'iso-17025-test-ve-kalibrasyon-laboratuvari-akreditasyonu'
    },
    {
      id: 43,
      category: 'Kalite Yönetimi',
      categorySlug: 'kalite',
      title: 'IATF 16949 Otomotiv Kalite Yönetim Sistemi',
      excerpt: 'Otomotiv sektörü tedarikçileri için ISO 9001 tabanlı IATF 16949 standardı, özel gereklilikler ve sertifikasyon.',
      image: 'https://readdy.ai/api/search-image?query=IATF%2016949%20automotive%20quality%20management%20system%20certification%20for%20suppliers%2C%20professional%20automotive%20industry%20compliance%20documentation%2C%20clean%20corporate%20photography%20showing%20ISO%209001%20based%20standards%20and%20manufacturing%20excellence&width=800&height=500&seq=blog-iatf16949-otomotiv&orientation=landscape',
      slug: 'iatf-16949-otomotiv-kalite-yonetim-sistemi'
    },
    {
      id: 44,
      category: 'Gıda Güvenliği',
      categorySlug: 'gida-guvenligi',
      title: 'BRC Global Standard Gıda Güvenliği Sertifikasyonu',
      excerpt: 'İngiliz perakende konsorsiyumu tarafından geliştirilen BRC standardı, GFSI tanınırlığı ve sertifikasyon gereklilikleri.',
      image: 'https://readdy.ai/api/search-image?query=BRC%20Global%20Standard%20food%20safety%20certification%20for%20retail%20suppliers%2C%20GFSI%20recognition%20documentation%2C%20professional%20food%20industry%20compliance%20workspace%20showing%20British%20retail%20consortium%20requirements&width=800&height=500&seq=blog-brc-gida&orientation=landscape',
      slug: 'brc-global-standard-gida-guvenligi-sertifikasyonu'
    },
    {
      id: 45,
      category: 'Gıda Güvenliği',
      categorySlug: 'gida-guvenligi',
      title: 'IFS Food Uluslararası Gıda Standardı',
      excerpt: 'Alman ve Fransız perakendeciler tarafından kabul edilen IFS Food standardı, denetim süreci ve puanlama sistemi.',
      image: 'https://readdy.ai/api/search-image?query=IFS%20Food%20international%20food%20standard%20certification%20for%20European%20retailers%2C%20professional%20audit%20process%20documentation%20showing%20scoring%20system%2C%20clean%20corporate%20photography%20with%20German%20and%20French%20retail%20acceptance&width=800&height=500&seq=blog-ifs-food&orientation=landscape',
      slug: 'ifs-food-uluslararasi-gida-standardi'
    }
  ];

  useSEO({
    title: 'Bilgi Merkezi | KGM Danışmanlık - ISO, İhracat, Teşvik ve Kalite Rehberleri',
    description: 'KGM Danışmanlık Bilgi Merkezi: ISO belgelendirme, ihracat süreçleri, devlet teşvikleri, kalibrasyon, yazılım çözümleri ve kalite yönetim sistemleri hakkında uzman makaleleri. TÜRKAK, CE, SABER, EAC, ISO 9001, ISO 14001, ISO 45001, ISO 22000 rehberleri.',
    keywords: 'ISO rehberi, ihracat belgeleri, SABER sistemi, CE işareti, TÜRKAK kalibrasyon, yatırım teşvikleri, KOSGEB destekleri, ISO 9001, ISO 22000, FSSC 22000, kalite yönetimi, gıda güvenliği',
    canonical: '/blog',
    ogType: 'website',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Blog',
      name: 'KGM Danışmanlık Bilgi Merkezi',
      description: 'ISO belgelendirme, ihracat, teşvik ve kalite yönetim sistemleri hakkında uzman makaleleri',
      url: `${siteUrl}/blog`,
      publisher: {
        '@type': 'Organization',
        name: 'KGM Danışmanlık',
        url: siteUrl,
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.readdy.ai/image/2b1409af55cbbc24ae624602859a344f/49982b335b96708abcb5cab4610886b0.png',
        },
      },
      blogPost: articles.slice(0, 10).map((article) => ({
        '@type': 'BlogPosting',
        headline: article.title,
        description: article.excerpt,
        datePublished: '2025-01-01',
        author: {
          '@type': 'Organization',
          name: 'KGM Danışmanlık',
        },
        publisher: {
          '@type': 'Organization',
          name: 'KGM Danışmanlık',
        },
      })),
    },
  });

  const filteredArticles = articles.filter(article => {
    const matchesCategory = activeFilter === 'Tümü' || article.category === activeFilter;
    const matchesSearch = article.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         article.excerpt.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#2D3436] to-[#1a1d1f] overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23C17F59' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}></div>
        </div>

        <div className="max-w-7xl mx-auto px-6 relative">
          <div className="text-center">
            <div className="inline-flex items-center bg-[#C17F59]/10 backdrop-blur-sm border border-[#C17F59]/30 px-5 py-2.5 rounded-lg mb-6">
              <i className="ri-book-open-line text-[#C17F59] mr-2"></i>
              <span className="text-[#C17F59] text-sm font-semibold">Bilgi Merkezi</span>
            </div>

            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight">
              Endüstriyel Çözümler<br />
              <span className="text-[#C17F59]">Bilgi Merkezi</span>
            </h1>

            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed mb-10">
              Devlet izinlerinden ihracat belgelerine, teşviklerden dijital dönüşüme, tüm ISO standartlarından kalibrasyon hizmetlerine kadar kapsamlı uzman içerikler
            </p>

            {/* Search Bar */}
            <div className="max-w-2xl mx-auto">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Makale ara..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full px-6 py-4 pl-14 rounded-lg bg-white/10 backdrop-blur-sm border border-white/20 text-white placeholder-gray-400 focus:outline-none focus:border-[#C17F59] transition-all text-base"
                />
                <i className="ri-search-line absolute left-5 top-1/2 -translate-y-1/2 text-gray-400 text-xl"></i>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Filter Bar */}
      <section className="sticky top-20 z-40 bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-wrap items-center justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category.slug}
                onClick={() => setActiveFilter(category.name)}
                className={`px-6 py-2.5 rounded-lg text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  activeFilter === category.name
                    ? 'bg-[#C17F59] text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          {/* Stats */}
          <div className="mb-12 text-center">
            <p className="text-lg text-gray-600">
              <strong className="text-[#C17F59] text-2xl font-bold">{filteredArticles.length}</strong> makale bulundu
            </p>
          </div>

          {filteredArticles.length === 0 ? (
            <div className="text-center py-20">
              <i className="ri-file-search-line text-6xl text-gray-300 mb-4"></i>
              <p className="text-xl text-gray-600">Aradığınız kriterlere uygun makale bulunamadı.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/blog/${article.slug}`}
                  className="group bg-white rounded-xl overflow-hidden shadow-[0_2px_20px_rgba(0,0,0,0.08)] hover:shadow-[0_8px_30px_rgba(193,127,89,0.15)] transition-all duration-300 border border-gray-100 hover:border-[#C17F59]/30 hover:-translate-y-2 cursor-pointer"
                >
                  {/* Image */}
                  <div className="relative h-56 w-full overflow-hidden bg-gray-100">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="inline-block bg-[#C17F59] text-white px-4 py-1.5 rounded-lg text-xs font-semibold">
                        {article.category}
                      </span>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-[#2D3436] mb-3 leading-tight group-hover:text-[#C17F59] transition-colors">
                      {article.title}
                    </h3>

                    <p className="text-sm text-gray-600 mb-4 leading-relaxed line-clamp-3">
                      {article.excerpt}
                    </p>

                    <div className="flex items-center text-[#C17F59] font-semibold text-sm group-hover:gap-2 transition-all">
                      <span>Devamını Oku</span>
                      <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#F8F9FA]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-[#2D3436] mb-4">
            İşletmeniz İçin Özel Danışmanlık
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            Hangi süreçte olursanız olun, uzman ekibimiz size özel çözümler sunmaya hazır
          </p>
          <Link
            to="/#iletisim"
            className="inline-flex items-center bg-[#C17F59] text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-[#A66B47] transition-all hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            <span>Ücretsiz Danışmanlık Alın</span>
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
